import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";
import { useFormatters } from "../shared/format";
import type { useConversationActions } from "./inbox-api";
import type { ConversationDetail } from "./inbox-model";
import { snoozeEnd, snoozeWhen } from "./snooze";
import { UnsnoozeButton } from "./unsnooze-button";

interface SnoozeBlockProps {
  detail: ConversationDetail;
  actions: ReturnType<typeof useConversationActions>;
  canReply: boolean;
  now: number;
}

/** Details pane: when a snoozed conversation wakes, and the Unsnooze action. Nothing while it is awake. */
export function SnoozeBlock({ detail, actions, canReply, now }: SnoozeBlockProps) {
  const { t } = useTranslation();
  const fmt = useFormatters();
  const until = snoozeEnd(detail.conversation, now);
  if (!until) return null;
  return (
    <div className="space-y-2" data-testid="snooze-block">
      <div className="label">{t("engage.inbox.snooze.heading")}</div>
      <p className="flex items-start gap-2 text-xs text-fg-muted">
        <Icon name="clock" className="mt-0.5 size-3.5 shrink-0" />
        {t("engage.inbox.snooze.wakes", { when: snoozeWhen(until, now, fmt) })}
      </p>
      <UnsnoozeButton conversation={detail.conversation} actions={actions} canReply={canReply} now={now} testId="unsnooze-details" />
    </div>
  );
}
